/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Button, Grid, Paper, TextField, ThemeProvider} from "@mui/material";
import {SEText} from "../../../../components/SEText";
import {Controller, useForm} from "react-hook-form";
import {EditarAtendimentoService} from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import {removeEmpty, sortByDirection} from "../../../../utils/utils";
import {BaSeDialogContext} from "@base/react";
import useFormMutation from "../../hooks/useFormMutation";
import theme from "../../../../mui-theme";
import {useHistory} from "react-router-dom";
import {useLocation} from "react-router";
import {TextFieldCounter} from "../../../../components/TextFieldCounter";
import {SEFormUserAction} from "../../../../components/SEFormUserAction";
import {formatDateTime, formatHoursToBRWithoutSeconds, stringToDate} from "../../../../../utils/time";
import {CidadeService} from "../../../../../pages/tabelasDeControle/services/cidadeService";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import styled from "styled-components";
import {RiSearchLine} from "react-icons/ri";
import {onlyNumbers, parseStringToJson} from "../../../../../utils/utils";

const CustomIcon = styled(RiSearchLine)(({theme}) => ({
    fill: theme.palette.primary.main,
    height: 26,
    width: 26,
    top: "calc(50% - .75em) !important",
}));


export interface AtendimentoEdicaoInterface {
    id: any
    cpf: any
    cnpj: any
    dataHoraInicio: string
    dataHoraFim: string
    porte: string
    cep: string
    endereco: string
    bairro: string
    cidade: any
    uf: any
    projetoAcao: any
    idSas: string
    codEstado: any
    acao: any
    dataAtendimento?: any,
    nomeFantasia?: any,
}

const Formulario = () => {

    const {showModal} = React.useContext(BaSeDialogContext);
    const history = useHistory();
    const location = useLocation();
    const hasCopyParam = location.pathname.includes('/copy');

    const {formData: editFormData, setFormData: handleShowForm} = useRenderFormStore();

    const [options, setOptions] = useState<any>({});
    const [cidades, setCidades] = useState([]);
    const [acoes, setAcoes] = useState([]);


    const getOptions = async () => {
        const response = await EditarAtendimentoService.getOptions(true);
        response?.portes?.length && sortByDirection(response.portes, 'nomePorte', 'ASC');
        setOptions(response);
    };

    const getCidades = async (siglaUF: any) => {
        console.log('getCidades', siglaUF);
        if (siglaUF) {
            try {
                const response = await CidadeService.findByUF(siglaUF);
                sortByDirection(response, 'nome', 'ASC');
                setCidades(response);
                return response;
            } catch (error) {
                console.error('Erro ao buscar cidades:', error);
            }
        }
    };

    const getAcaoByUF = async (siglaUF: any) => {
        if (siglaUF) {
            try {
                const response = await EditarAtendimentoService.findAcoesByUF(siglaUF);
                setAcoes(response);
                return response
            } catch (error) {
                console.error('Erro ao buscar ações:', error);
            }
        }
    };

    const dataForm: AtendimentoEdicaoInterface = {
        id: null,
        cpf: null,
        cnpj: null,
        dataAtendimento: '',
        dataHoraInicio: '',
        dataHoraFim: '',
        porte: '',
        cep: '',
        endereco: '',
        bairro: '',
        cidade: null,
        uf: null,
        projetoAcao: null,
        idSas: '',
        codEstado: null,
        acao: null,
        nomeFantasia: null
    }

    // const [setFormData] = useState<AtendimentoEdicaoInterface>(editFormData?.id ? editFormData : dataForm);

    const {control, handleSubmit, reset, setValue} = useForm<AtendimentoEdicaoInterface>({
        defaultValues: dataForm,
    });
    const onResetFields = () => {
        reset({
            id: null,
            cpf: null,
            cnpj: null,
            dataHoraInicio: '',
            dataHoraFim: '',
            porte: '',
            cep: '',
            endereco: '',
            bairro: '',
            cidade: null,
            uf: null,
            projetoAcao: null,
            idSas: '',
            codEstado: null,
            acao: null,
            nomeFantasia: null
        });
    };

    const goBack = () => {
        handleShowForm(false);
        history.push(`/tabelas-de-controle/editar-atendimento`);
    };


    useEffect(() => {
        async function loadedData() {
            const data = editFormData;
            if (data?.id) {
                const ufSigla = data?.empreendedor?.dadoComplementar?.siglaEstado || data?.empreendedor?.uf || data?.uf?.sigla;
                try {
                    // Buscando as cidades com base no estado (ufSigla)
                    await getCidades(ufSigla);
                    const acoes = await getAcaoByUF(ufSigla);
                    const acaoSelecionada = acoes?.find((a: any) => a.id === data?.apr?.acao?.id);
                    const { empreendedor } = data;

                    // Aqui removemos o reset para fazê-lo depois de setar a cidade no segundo useEffect
                    delete data?.cidade?.uf;
                    setValue('cnpj', empreendedor?.cnpj);
                    setValue('cpf', (empreendedor?.respondente?.cpf ?? empreendedor?.cpfPessoaResponsavel));
                    setValue('cep', empreendedor?.dadoComplementar?.cep);
                    setValue('endereco', empreendedor?.logradouro);
                    setValue('bairro', empreendedor?.bairro);
                    setValue('dataAtendimento', stringToDate(data?.dataAtendimento));
                    setValue('dataHoraInicio', formatHoursToBRWithoutSeconds(data?.apr?.inicioAtendimento));
                    setValue('dataHoraFim', formatHoursToBRWithoutSeconds(data?.apr?.fimAtendimento));
                    setValue('idSas', data?.apr?.codInteracaoSas ?? '');
                    setValue('acao', acaoSelecionada);
                    setValue('nomeFantasia', empreendedor?.dadoComplementar?.nomeFantasia);

                } catch (error) {
                    console.error('Erro ao carregar dados:', error);
                }
            }
        }

        loadedData();
        // eslint-disable-next-line
    }, [editFormData, setValue]);

    useEffect(() => {
        if (cidades.length) {
            const data = editFormData;
            if (editFormData?.id) {
                const cidade = data?.empreendedor?.dadoComplementar?.cidade || data?.empreendedor?.cidade?.nome;
                const cidadeSelecionada = cidades.find((c: any) => c.nome === cidade);
                if (cidadeSelecionada) {
                    setValue('cidade', cidadeSelecionada);
                    reset({ ...editFormData, cidade: cidadeSelecionada });
                }
            }
        }
    }, [cidades, editFormData, reset, setValue]);

    useEffect(() => {
        getOptions();
    }, []);


    const {
        updateMutation,
    } = useFormMutation({
        showModal,
        service: EditarAtendimentoService,
        onCloseModalSuccess: () => {
            onResetFields();
            goBack()
        },
        onCloseModalUpdate: () => goBack(),
        onCloseModalError: () => {
        },
    });

    const submitForm = async (dataForm: AtendimentoEdicaoInterface) => {
        const cleanedData = removeEmpty(dataForm);
        let sendForm: any = {};
        sendForm.id = cleanedData.id
        sendForm.cep = onlyNumbers(cleanedData.cep)
        sendForm.uf = parseStringToJson(cleanedData.uf);
        sendForm.porte = parseStringToJson(cleanedData.porte);
        sendForm.acao = parseStringToJson(cleanedData.acao);
        sendForm.cidade = parseStringToJson(cleanedData.cidade);
        sendForm.bairro = cleanedData.bairro;
        sendForm.endereco = cleanedData.endereco;
        sendForm.dataHoraInicio = cleanedData.dataHoraInicio ? formatDateTime(cleanedData.dataAtendimento, cleanedData.dataHoraInicio) : null;
        sendForm.dataHoraFim = cleanedData.dataHoraFim ? formatDateTime(cleanedData.dataAtendimento, cleanedData.dataHoraFim) : null;
        sendForm.nomeFantasia = cleanedData.nomeFantasia;
        if (sendForm.id) {
            await updateMutation(sendForm).then();
        }
    }

    const handleLabelProjetoAcao = (item: any) => {
        const {projeto} = item;
        if (projeto) {
            return (`${projeto.nuPratif} - ${projeto.nomePratif} - ${item.nomeAcao}`);
        }
        return item?.descricao ? item?.id + ' - ' + item?.descricao : item?.id + ' - ' + item?.nomeAcao
    }

    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                padding: 2,
            }}
        >
            <ThemeProvider theme={theme}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SEText
                            as="h2"
                            size={"medium"}
                            font="Mulish"
                            weight="bold"
                            color="#7B80FF"
                        >
                            {editFormData?.id ? (hasCopyParam ? 'Copiar' : 'Editar') : 'Incluir'}
                        </SEText>
                    </Grid>

                    <Grid container item spacing={3}>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="cnpj"
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            disabled={true}
                                            id="cnpj"
                                            label="CNPJ *"
                                            placeholder="Digite o tipo de registro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            inputProps={{maxLength: 255}}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="cpf"
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            disabled={true}
                                            id="CPF"
                                            label="CPF *"
                                            placeholder="Digite o tipo de registro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            inputProps={{maxLength: 255}}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="idSas"
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            disabled={true}
                                            id="idSas"
                                            label="ID SAS *"
                                            placeholder="Digite o ID SAS"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            inputProps={{maxLength: 255}}
                                        />
                                        <TextFieldCounter value={value} maxLength={255}/>
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                    </Grid>

                    <Grid container item spacing={3}>
                        <Grid item md={3}>
                            <Controller
                                control={control}
                                name="dataAtendimento"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            label="Data *"
                                            type={'date'}
                                            placeholder="Digite a data"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                        />
                                        <TextFieldCounter value={value} maxLength={255}/>
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={3}>
                            <Controller
                                control={control}
                                name="dataHoraInicio"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="dataHoraInicio"
                                            label="Hora início *"
                                            placeholder="Digite o tipo de registro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            type={"time"}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={3}>
                            <Controller
                                control={control}
                                name="dataHoraFim"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="dataHoraFim"
                                            label="Hora fim *"
                                            placeholder="Digite o tipo de registro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            inputProps={{maxLength: 255}}
                                            type={"time"}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={3}>
                            <Controller
                                control={control}
                                name="porte"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <>
                                            <SEFilterSelect
                                                id={"porte"}
                                                defaultOption={"Selecione uma das opções"}
                                                IconComponent={CustomIcon}
                                                label="Porte *"
                                                value={value}
                                                onChange={onChange}
                                                options={options?.portes}
                                                error={error}
                                                displayField={'nomePorte'}
                                            />
                                        </>
                                    </>
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid item md={8}>
                        <Controller
                            control={control}
                            name="nomeFantasia"
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field: {value, onChange}, fieldState: {error}}) => (
                                <>
                                    <TextField
                                        id="nomeFantasia"
                                        label="Razão Social *"
                                        placeholder="Digite a razão social"
                                        fullWidth
                                        value={value || ""}
                                        onChange={onChange}
                                    />
                                    {error && (
                                        <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid container item spacing={3}>
                        <Grid item md={1}>
                            <Controller
                                control={control}
                                name="cep"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="cep"
                                            label="CEP *"
                                            placeholder="Digite o CEP"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="endereco"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="endereco"
                                            label="Endereço *"
                                            placeholder="Digite o Endereço"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={2}>
                            <Controller
                                control={control}
                                name="bairro"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="bairro"
                                            label="Bairro *"
                                            placeholder="Digite o Bairro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={2}>
                            <Controller
                                control={control}
                                name="uf"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <>
                                            <SEFilterSelect
                                                id={"uf"}
                                                defaultOption={"Selecione uma das opções"}
                                                IconComponent={CustomIcon}
                                                label="UF *"
                                                value={value}
                                                onChange={onChange}
                                                options={options?.ufs}
                                                error={error}
                                                displayField={'sigla'}
                                            />
                                        </>
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item md={3}>
                            <Controller
                                control={control}
                                name="cidade"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <>
                                            <SEFilterSelect
                                                displayField={'nome'}
                                                id={"cidade"}
                                                defaultOption={"Selecione a UF"}
                                                IconComponent={CustomIcon}
                                                label="Cidade *"
                                                value={value}
                                                onChange={onChange}
                                                options={cidades}
                                                error={error}
                                            />
                                        </>
                                    </>
                                )}
                            />
                        </Grid>

                    </Grid>

                    <Grid container item spacing={3}>
                        <Grid item md={12}>
                            <Controller
                                control={control}
                                name="acao"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <>
                                            <SEFilterSelect
                                                id={"acao"}
                                                defaultOption={"Selecione uma das opções"}
                                                IconComponent={CustomIcon}
                                                label="Projeto/Ação *"
                                                value={value}
                                                onChange={onChange}
                                                options={acoes}
                                                error={error}
                                                customLabel={handleLabelProjetoAcao}
                                            />
                                        </>
                                    </>
                                )}
                            />
                        </Grid>
                    </Grid>


                    <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
                        <Button variant="outlined" onClick={goBack}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit(submitForm)}
                            disabled={false}
                        >
                            {editFormData?.id ? (hasCopyParam ? 'Incluir' : 'Editar') : 'Incluir'}
                        </Button>
                    </Grid>

                    <Grid item md={12}>
                        <SEFormUserAction data={editFormData}/>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </Paper>
    );
};

export default Formulario;
